import React from 'react';
import store from '../store';
import {Link} from 'react-router-dom';
import {newGameSocket, refreshRoomsListSocket} from '../actions/gameManagement';
import {newMatchLocal, addToRosterSocket} from '../actions/matchManagement';

export default class GameNew extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            gameroom: '',
            location: '',
            password: ''
        };
    }

    fieldUpdate(e, key){
        this.setState({
            ...this.state,
            [key]: e.target.value
        })
    }

    //region Socket.IO
    createNewGame(e){
        // Create Socket room & add Roster property to it.
        const payload = {
            gameroom: this.state.gameroom,
            location: this.state.location,
            roster: {}
        };

        store.dispatch(newGameSocket(this.props.socket, payload)); // Socket Room
        store.dispatch(refreshRoomsListSocket(this.props.socket));
        store.dispatch(newMatchLocal(payload.gameroom, payload.location)); // Local Game
        store.dispatch(addToRosterSocket(this.props.socket, store.getState().match.gameroom , store.getState().user.gamertag));
    }
    //endRegion

    render(){
        return(
            <div id="game-new" style={{marginTop: "1rem", textAlign: "center"}} className="menuWrapper">
                <h3>New Game</h3>
                <form>
                    <label>Gameroom Name:</label><br/>
                    <input id="ip-gameroom" type="text" className="btnStretch" onChange={e=>this.fieldUpdate(e, 'gameroom')}/><br/>
                    <label>Location:</label><br/>
                    <input id="ip-location" type="text" className="btnStretch" onChange={e=>this.fieldUpdate(e, 'location')}/><br/>
                    <Link to="/main/game">
                        <input id="ip-create-room" type="button" value="Create Room" onClick={(e)=>{this.createNewGame(e)}} className="btnStretch btnColoring" style={{marginTop: ".5rem", marginBottom: '1rem'}}/>
                    </Link>
                </form>
            </div>
        );
    }
}

export {GameNew as GameNewPure};


// WEBPACK FOOTER //
// ./src/comps/gameNew.js